/**
 * copy-paste https://github.com/vueuse/vueuse/issues/1592#issuecomment-1381020982
 * @note UseTimeAgo and i18n are not fully compatible with relative times, so that's why we have the code below.
 * @note We abuse the translations a bit, because in Spanish, the position of the dynamic number differs, for example
 * "2 minutes ago" in Spanish: "Hace 2 minutos" and we now only use this for times in the past.
 *
 * @todo i18n yells "inject() can only be used inside setup()..."
 */
import i18n from "@/libs/i18n";
import { useTimeAgo, UseTimeAgoMessages, UseTimeAgoUnitNamesDefault } from "@vueuse/core";

export function localeTimeAgo(date: Date) {
    const I18N_MESSAGES: UseTimeAgoMessages<UseTimeAgoUnitNamesDefault> = {
        justNow: i18n.t("timeAgo.just-now"),
        past: (n) => (n.match(/\d/) ? i18n.tc("timeAgo.ago", n) : n),
        future: (n) => (n.match(/\d/) ? i18n.tc("timeAgo.in", n) : n),
        month: (n, past) =>
            n === 1
                ? past
                    ? i18n.t("timeAgo.last-month")
                    : i18n.t("timeAgo.next-month")
                : i18n.tc(`timeAgo.month`, n),
        year: (n, past) =>
            n === 1 ? (past ? i18n.t("timeAgo.last-year") : i18n.t("timeAgo.next-year")) : i18n.tc(`timeAgo.year`, n),
        day: (n, past) =>
            n === 1 ? (past ? i18n.t("timeAgo.yesterday") : i18n.t("timeAgo.tomorrow")) : i18n.tc(`timeAgo.day`, n),
        week: (n, past) =>
            n === 1 ? (past ? i18n.t("timeAgo.last-week") : i18n.t("timeAgo.next-week")) : i18n.tc(`timeAgo.week`, n),
        hour: (n) => i18n.tc("timeAgo.hour", n),
        minute: (n) => i18n.tc("timeAgo.minute", n),
        second: (n) => i18n.tc(`timeAgo.second`, n),
        invalid: "",
    };

    return useTimeAgo(date, {
        fullDateFormatter: (date: Date) => date.toLocaleDateString(),
        messages: I18N_MESSAGES,
        updateInterval: 59000, // 5min
    });
}
